module.exports = __webpack_public_path__ + "img/pexels-godisable-jacob-2703181.2b06df25.jpg";